
































import mixins from 'vue-typed-mixins';
import { DataTableHeader } from 'vuetify';
import ProviderUtils, { ServiceProvider } from '../../utils/ProviderUtils';
export default mixins().extend({
  computed: {
    headers(): DataTableHeader<ServiceProvider>[] {
      return [
        { text: this.$i18n.tc('model.common.name', 2), value: 'name' },
        {
          text: this.$i18n.tc('model.common.type', 2),
          value: 'serviceprovidertype.name',
        },
         { text: this.$i18n.tc('model.common.state', 2), value: 'state' },
      ];
    },
  },
  data(): {
    instances: ServiceProvider[] | undefined;
    search: string;
    showInactive: boolean;
  } {
    return {
      instances: undefined,
      search: '',
      showInactive:false,
    };
  },
  async mounted() {
    try {
      this.instances = await ProviderUtils.api.instance.list({showinactive: this.showInactive,});
    } catch (error) {
      this.$alert.show('mount', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },
  methods: {
    async create() {
      await this.$router.push({ name: 'provider-create' });
    },
    async edit(provider: ServiceProvider) {
      await this.$router.push({
        name: 'provider-edit',
        params: { id: `${provider.id}` },
      });
    },
    async remove(provider: ServiceProvider) {
      await this.$confirm(
        this.$i18n
          .t('validation.confirmation.delete', [this.$translate(provider.name)])
          .toString(),
        async () => {
          if (provider.id && this.instances) {
            this.$alert.hide('remove');
            await ProviderUtils.api.instance.remove(provider.id);

            this.$toast.push({
              type: 'success',
              text: this.$languageobj('validation.success.delete', {
                values: [provider.name],
              }),
            });

            const index = this.instances.findIndex(
              (val) => val.id === provider.id
            );
            if (index >= 0) {
              this.instances.splice(index, 1);
            }
          }
        }
      );
    },
    
  },

    watch: {
    async showInactive(newValue) {
      try {
        this.instances = undefined;
        this.instances = await ProviderUtils.api.instance.list({showinactive: newValue,});
      } catch (error) {
        this.$alert.show('mount', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },
  },
});
